let html = `<div class="account-modal-split">
    <div class="account-modal-split__qr">
        <img class="account-modal-split__qr-img hide" />
        <div class="account-modal-split__qr-code"></div>
        <div class="account-modal-split__qr-text">#{premium_scan_qr}</div>
    </div>

    <div class="account-modal-split__info">
        <div class="account-modal-split__title" style="font-weight: 600;">#{premium_need_title}</div>
        <div class="account-modal-split__text">#{premium_need_text}</div>

        <div class="account-modal-split__text">#{premium_open_bot}</div>

        <a class="account-modal-split__bot-link" target="_blank" rel="noopener"></a>

        <div class="account-modal-split__text">#{premium_tap_pay}</div>
    </div>
</div>`

export default html
